import { jsx as _jsx } from "react/jsx-runtime";
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { cn } from '@fortem-monorepo/js-utilities';
function Collapsible({ ...props }) {
    return _jsx(CollapsiblePrimitive.Root, { "data-slot": "collapsible", ...props });
}
function CollapsibleTrigger({ ...props }) {
    return _jsx(CollapsiblePrimitive.CollapsibleTrigger, { "data-slot": "collapsible-trigger", ...props });
}
function CollapsibleContent({ className, ...props }) {
    return (_jsx(CollapsiblePrimitive.CollapsibleContent, { "data-slot": "collapsible-content", className: cn('CollapsibleContent', className), ...props }));
}
export { Collapsible, CollapsibleTrigger, CollapsibleContent };
